<template>
  <no-ssr-loader>
    <b-container class="py-5">
      <b-row align-v="center">
        <b-col
          cols="12"
          md="8"
        >
          <h1 class="mb-3">
            Product Catalogues
          </h1>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="text-right"
        >
          <b-button
            variant="primary"
            to="/catalogues/new"
          >
            Create Product Catalogue
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <catalogues-table v-if="!errorLoading" />
          <div
            v-else
            class="text-center py-5"
          >
            <b-icon
              class="h2"
              icon="exclamation-triangle"
              large
              variant="danger"
            />
            <h5>An error occurred while attempting to load the product catalogues.</h5>
            <b-button
              :disabled="retryAttempted"
              variant="primary"
              @click="retry"
            >
              Retry
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </no-ssr-loader>
</template>

<script>
import { mapActions } from 'vuex'
import CataloguesTable from '../components/CataloguesTable'
import { BIcon } from 'bootstrap-vue'

export default {
  name: 'catalogues-dashboard',
  components: {
    CataloguesTable,
    BIcon
  },
  data: () => ({
    retryAttempted: false
  }),
  computed: {
    errorLoading() {
      return this.$store.getters['catalogues/errorLoading']
    }
  },
  mounted() {
    this.loadCatalogues()
  },
  methods: {
    ...mapActions({
      loadCatalogues: 'catalogues/loadCatalogues'
    }),
    retry() {
      this.retryAttempted = true
      this.loadCatalogues()
    }
  }
}
</script>
